<template>
  <div>
    <!-- Top banner -->
    <div class="banner" v-bind:style="{ backgroundImage: 'url(' + acf.acf.image + ')' }">
        <h1 class="majorHeading container">{{acf.acf.text_first_line}} <br> {{acf.acf.text_second_line}} <br> {{acf.acf.text_third_line}}</h1>
    </div>
    <!-- Executive Club and Concept Section -->
    <div class="pad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12" class="leftPad">
                    <div v-for="(a, index) in acf.acf.series_first_section" :key="'thirtydex' +index">
                        <h1 class="heading" >{{a.title}}</h1>
                        <p v-html="a.text"></p>
                    </div>
                    <div v-for="(b, index) in acf.acf.series_second_section" :key="'thirtyonedex' +index" style="margin-top: 40px">
                        <h1 class="heading" >{{b.title}}</h1>
                        <p v-html="b.text"></p>
                    </div>
                </b-col>
                <b-col lg="6" sm="12">
                    <!-- <img class="rightImageCon" :src="acf.acf.right_image"> -->
                    <!-- <div v-for="(ex, index) in acf.acf.executive_club_image_rotate" :key="'fiftydex' +index" style="margin-top: 40px" class="executiveImages" v-bind:style="{ backgroundImage: 'url(' + ex.executive_images + ')' }"> -->
                    <!-- <div v-for="(ex, index) in acf.acf.executive_club_image_rotate" :key="'fiftydex' +index" style="margin-top: 40px" class="executiveImages">
                        <img class="exImageNonback" :src="ex.executive_images">
                    </div> -->
                    <div>
                        <div class="slidetrans">
                        <transition-group name="fade">
                            <div v-for="i in [currentIndex]" class="executiveImages" :key="i">
                                <img class="execImage" :src="currentImg.series_images" />
                            </div>
                        </transition-group>
                        <a class="prev" @click="prev">&#10094;</a>
                        <a class="next" @click="next">&#10095;</a>
                        </div>
                    </div>
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <!-- Tour Membership -->
    <MembershipBanner/>
  </div>

</template>

<script>
import axios from 'axios'
import MembershipBanner from "@/components/membershipBanner.vue";
export default {
  name: 'Executive Page',
  components: {
    MembershipBanner
  },
  data: function() {
    return {
      acf: [],
      acfMessage:'',
      timer: null,
      currentIndex: 0
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    // startSlide: function() {
    //   this.timer = setInterval(this.next, 8000);
    // },

    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    }
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/1505"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
    // this.startSlide()
  },
  computed: {
    currentImg: function() {
      return this.acf.acf.image_rotate[Math.abs(this.currentIndex) % this.acf.acf.image_rotate.length];
    }
  }
}
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.9s ease;
        overflow: hidden;
        visibility: visible;
        /* position: absolute; */
        /* width:100%; */
        opacity: 1;
        height: 650px;
    }

    .fade-enter,
    .fade-leave-to {
        visibility: hidden;
        /* width:100%; */
        opacity: 0;
        height: 650px;
        overflow: hidden;
    }

    .execImage {
        height: 650px;
        width:100%;
        overflow: hidden;
    }

    .prev, .next {
        cursor: pointer;
        position: absolute; 
        top: 45%;
        width: auto;
        padding: 16px;
        color: white;
        font-weight: bold;
        font-size: 18px;
        transition: 0.7s ease;
        border-radius: 6px;
        text-decoration: none;
        user-select: none;
        background-color: #081c3f;
    }

    .next {
        right: 30px;
    }

    .prev {
        left: -25px;
    }

    .prev:hover, .next:hover {
        background-color: rgba(0,0,0,0.9);
    }
    .exImageNonback {
        width: 100%;
    }
    .executiveImages {
        height: 650px;
        /* width: 100%; */
        position: absolute;
        left: 12%;
    }
    ::v-deep h4 {
        font-weight: bold;
        font-size: 20px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
    .BannerText {
        font-size: 45px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .aboutImage {
        width: 100%;
    }
    .rightImageCon {
        width: 100%;
    }
    .majorHeading {
        color: #FFFFFF;
        font-size: 65px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 200px;
    }
    .banner {
        width: 100%;
        height: 712px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
    .blueBanner {
        background-color: #081C3F;
        color: #fff;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .backgroundGrey {
        background-color: #F2F2F2;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    h1.heading {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p {
        font-size: 18px;
        color: #081C3F;
    }
    .pad {
        padding-top: 100px;
        padding-bottom: 100px;
    }
    @media only screen and (max-width: 1340px) {
        .next {
            right: 30px;
        }
        .prev {
            left: 40px;
        }
    }
    @media only screen and (max-width: 1280px) {
        .next {
            right: 0px;
        }
    }
    @media only screen and (max-width: 1366px) {
        .banner {
            height: 512px;
        }
        .majorHeading {
            color: #FFFFFF;
            font-size: 65px;
            font-weight: bold;
            position: relative;
            top: 120px;
        }
    }

    @media only screen and (min-width: 1280px) {
        .leftPad {
            padding-right: 60px;
        }
    }
    @media only screen and (max-width: 1199px) {
        .majorHeading {
            display: none;
        }
    }
    @media only screen and (max-width: 990px) {
        .slidetrans {
            display: none;
        }
    }
    @media only screen and (max-width: 510px) {
        .banner {
            width: 100%;
            height: 160px;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .pad {
            padding-top: 30px;
            padding-bottom: 30px;
        }
        h1.heading {
            padding-top: 20px;
            color: #081C3F;
            font-size: 36px;
            /* font-weight: bold; */
            padding-bottom: 30px;
            font-family: "brown-pro-condensed", sans-serif;
            font-weight: 800;
            font-style: normal;
        }
    }
</style>
